<div ngbDropdown #myDropdown="ngbDropdown" class="dropdown" [placement]="'auto'" container="body" autoClose="outside">
    <button class="btn dropdown-toggle date-dropdown-button" ngbDropdownToggle id="dropdownMenuButton"
      aria-expanded="false">
      <!-- <img src="assets/images/calander.png" alt="calendar" style="width: 20px; height: 20px;"> -->
      Select From Given Options
    </button>
  
    <div ngbDropdownMenu aria-labelledby="dropdownMenuButton" class="dropdown-menu">
      <div
      style="display: flex; justify-content: space-between;"
      >
        <div
        style="flex: 1;"
        >
          <div *ngFor="let item of items" class="dropdown-item dropdown-list">
            <div class="innerBody" (click)="onItemSelect(item.value)">
              <label class="label-color">{{ item.text }}</label>
              <input type="radio" [value]="item.value">
            </div>
          </div>
        </div>

  
      </div>
    </div>
  </div>